import { app } from '../checkpointHelper/app';
import { isSecondaryCheckpointUser } from '../checkpointHelper/static/auth-types';
import { SETTINGS_APP_NAME } from './config';
import { getCurrentUser, teams } from './state';
import type { Team } from './types';

export function isPrimaryCheckpointUser(): boolean {
    return app.window.userType === 'normal';
}

export function getAppRole(): string | null {
    if (isPrimaryCheckpointUser()) {
        return 'admin';
    }

    if (!isSecondaryCheckpointUser(app.window.user)) {
        return null;
    }

    const role = app.window.user.apps[SETTINGS_APP_NAME]?.role;
    return role ? String(role) : null;
}

export function getAppRoleForApi(): string {
    return getAppRole() ?? '';
}

export function isSettingsAdmin(): boolean {
    if (isPrimaryCheckpointUser()) {
        return true;
    }

    return getAppRole()?.toLowerCase() === 'admin';
}

export function getCurrentPmUserId(): number {
    return getCurrentUser().id;
}

export function teamsForCurrentUser(): Team[] {
    if (isSettingsAdmin()) {
        return teams;
    }

    const pmUserId = getCurrentPmUserId();
    return teams.filter((team) => team.members.includes(pmUserId));
}
